import { Popconfirm } from 'antd';
import { observer } from 'mobx-react';
import React from 'react';

import store from 'stores/RootStore';

import FiltersToolbarButton from './FiltersToolbarButton';

function ClearAllFiltersButton() {
  const filterManager = store.creative?.ads.filter;

  const clearAllFilters = () => {
    filterManager?.resetToScratch();
  };

  return (
    <Popconfirm
      cancelText="No"
      okText="Yes"
      onConfirm={clearAllFilters}
      title="Clear all filters?"
    >
      <FiltersToolbarButton disabled={!filterManager} label="Clear All" />
    </Popconfirm>
  );
}

export default observer(ClearAllFiltersButton);
